import {
  Controller,
  Response,
} from 'external/dev_april_corgi+/js/corgi/controller';
import {EmptyDeps} from 'external/dev_april_corgi+/js/corgi/deps';
import {CorgiEvent, EventSpec} from 'external/dev_april_corgi+/js/corgi/events';
import {CHANGED} from 'external/dev_april_corgi+/js/emu/events';

import {Node} from './execution/graph';
import {RgbaU32} from './types/colors';

interface Args {
  node: Node;
  onUpdate: (node: Node) => void;
}

export interface State {}

export class NodeEditorController extends Controller<
  Args,
  EmptyDeps,
  HTMLElement,
  State
> {
  private readonly onUpdate: (node: Node) => void;
  private node: Node;

  constructor(response: Response<NodeEditorController>) {
    super(response);
    this.node = response.args.node;
    this.onUpdate = response.args.onUpdate;
  }

  recolor(e: CorgiEvent<EventSpec<unknown>>): void {
    this.node.color = Number(
      (e.actionElement.element() as HTMLInputElement).value,
    ) as RgbaU32;
    this.onUpdate(this.node);
  }

  rename(e: CorgiEvent<typeof CHANGED>): void {
    // TODO(april): this is *gross* but SceneGraph uses a WeakMap to hold node references and well
    this.node.label = e.detail.value;
    this.onUpdate(this.node);
  }
}
